import React from 'react';
import { Box } from '@mui/material';
import UndoRedoButtons from '../../UndoRedo/UndoRedoButtons';
import AutosizeColumnsToggle from '../../DataGrid/AutosizeColumnsToggle';
import ActiveViewIndicator from '../../Views/ActiveViewIndicator';
import { DanelView } from '../../../hooks/useViewManagement/types';

interface GridControlsProps {
  // Undo/Redo props
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  getUndoActionInfo: () => { description?: string } | null;
  getRedoActionInfo: () => { description?: string } | null;

  // Autosize props
  autosizeColumns: boolean;
  onAutosizeChange: (autosize: boolean) => void;

  // Active view props
  activeView: DanelView | null;
  viewModifications: string[];
  onClearActiveView: () => void;
  onUpdateCurrentView: () => void;
}

export const GridControls: React.FC<GridControlsProps> = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  getUndoActionInfo,
  getRedoActionInfo,
  autosizeColumns,
  onAutosizeChange,
  activeView,
  viewModifications,
  onClearActiveView,
  onUpdateCurrentView,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <UndoRedoButtons
          canUndo={canUndo}
          canRedo={canRedo}
          onUndo={onUndo}
          onRedo={onRedo}
          undoDescription={getUndoActionInfo()?.description}
          redoDescription={getRedoActionInfo()?.description}
          size="small"
        />
        <AutosizeColumnsToggle
          checked={autosizeColumns}
          onChange={onAutosizeChange}
        />
      </Box>
      {activeView && (
        <ActiveViewIndicator
          view={activeView}
          modifications={viewModifications}
          onClose={onClearActiveView}
          onUpdateView={onUpdateCurrentView}
        />
      )}
    </Box>
  );
};
